import { GlobalsComponent } from './debug/globals/globals.component';
import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { SigninComponent } from './authentication/signin/signin.component';
import { DashboardView } from './views/dashboard/dashboard.view';

declare var System: any;

const appRoutes: Routes = [
    // main redirect
    { path: '', redirectTo: 'account', pathMatch: 'full' },

    { path: 'cc/:token', component: SigninComponent },
    // dashboard views
    /*
    {
        path: 'dashboard', component: DashboardView,
        children: [
            { path: '', component: MainComponent },
            { path: 'home',  component: MainComponent },
        ]
    },
    */

    // debug
    {
        path: 'debug', component: DashboardView,
        children: [
            { path: '', component: GlobalsComponent },
            { path: 'globals', component: GlobalsComponent },
        ]
    },

    // handle all other routes
    { path: '**', redirectTo: 'account' }

];


@NgModule({
    imports: [RouterModule.forRoot(appRoutes, { preloadingStrategy: PreloadAllModules, relativeLinkResolution: 'legacy' })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
